import styled from '@emotion/styled';

export const MainBlock = styled.div`
  display: flex;
  gap: 14px;
  justify-content: space-between;
`;
